import { Box, Link, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

type ItemProps = {
  icon: ReactNode;
  primaryLabel: string;
  secondaryLabel: string;
  value: string;
  target?: string;
};

export const Item = ({
  icon,
  primaryLabel,
  secondaryLabel,
  value,
  target,
}: ItemProps) => {
  const theme = useTheme();
  return (
    <Box display="flex" gap={1} flexDirection="column" mb={3}>
      <Box display="flex" alignItems="center" gap={0.5}>
        {icon}
        <Typography variant="body2" sx={{color: theme.palette.secondary[800]}} textTransform="uppercase">
          {primaryLabel}
        </Typography>
      </Box>

      <Link
        target={target}
        href={value}
        sx={{
          textDecoration: "none",
          color: theme.palette.primary[700],
        }}
        variant="body2"
        textTransform="uppercase"
      >
        {secondaryLabel}
      </Link>
    </Box>
  );
};
